var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClasses,attrs:{"role":"alert","aria-relevant":"all"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.getIcon))]),_c('span',{staticClass:"alert__message"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }